import { render } from "./root.vue?vue&type=template&id=f50a1dd0&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"

import "./root.vue?vue&type=style&index=0&id=f50a1dd0&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50a1dd0"]])

export default __exports__